export const RULE_EVENT_OPTIONS = [
    { value: 'node.created', label: 'Node created' },
    { value: 'node.updated', label: 'Node updated' },
    { value: 'node.deleted', label: 'Node deleted' },
];

export const INCOMING_ACTION_OPTIONS = [
    { value: 'create', label: 'Create' },
    { value: 'update', label: 'Update' },
];
